<template>
  <div class="dialog_wrap">
    <el-dialog
      :visible.sync="visible"
      class="detail-dialog"
      title="修改密码"
      width="500px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :before-close="close"
    >
      <el-form
        :model="form"
        status-icon
        :rules="rules"
        ref="form"
        class="psw-form"
      >
        <el-form-item label="原密码" class="no-tips" prop="oldPassword">
          <el-input
            :type="type.old"
            v-model="form.oldPassword"
            autocomplete="off"
            placeholder="请输入原密码"
            maxlength="50"
          ></el-input>
          <template>
            <img
              v-if="type.old === 'password'"
              src="../../assets/images/yanjing-2.png"
              @click="showPassword('old')"
            />
            <img
              v-if="type.old === 'text'"
              src="../../assets/images/yanjing.png"
              @click="hidePassword('old')"
            />
          </template>
        </el-form-item>
        <el-form-item class="new-password" label="新密码" prop="newPassword">
          <span class="tips font-main-support"
            >密码格式要求为6-12位，需同时包含数字、小写字母、大写字母，特殊字符</span
          >
          <el-input
            :type="type.new"
            v-model="form.newPassword"
            autocomplete="off"
            placeholder="请输入新密码"
            maxlength="50"
          ></el-input>
          <template>
            <img
              v-if="type.new === 'password'"
              src="../../assets/images/yanjing-2.png"
              @click="showPassword('new')"
            />
            <img
              v-if="type.new === 'text'"
              src="../../assets/images/yanjing.png"
              @click="hidePassword('new')"
            />
          </template>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input
            :type="type.confirm"
            v-model="form.confirmPassword"
            autocomplete="off"
            placeholder="请确认新密码"
            maxlength="50"
          ></el-input>
          <template>
            <img
              v-if="type.confirm === 'password'"
              src="../../assets/images/yanjing-2.png"
              @click="showPassword('confirm')"
            />
            <img
              v-if="type.confirm === 'text'"
              src="../../assets/images/yanjing.png"
              @click="hidePassword('confirm')"
            />
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-footer" @click="close">取消</el-button>
        <el-button type="primary" v-preventReClick="1000" @click="submitForm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/utils/requst.js";
import { md5 } from '@/utils/md5.js'
export default {
  name: 'PasswordDialog',
  data() {
    return {
      type: {
        old: 'password',
        new: 'password',
        confirm: 'password',
      },
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: this.pass, message: '请输入正确格式的密码', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: this.checkpass, trigger: 'blur' }
        ]
      },
      password: '',
      id: ''
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: function () {
        return false;
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
      }
    }
  },
  mounted() {
  },
  methods: {
    // 密码
    pass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{6,12}$/.test(value)) {
          if (this.form.confirmPassword !== '') {
            this.$refs.form.validateField('confirmPassword')
          }
          callback()
        } else {
          callback(new Error('请输入正确格式的密码'))
        }
      }
    },
    // 再次确认密码
    checkpass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    showPassword(type) {
      this.type[type] = 'text'
    },
    hidePassword(type) {
      this.type[type] = 'password'
    },
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          api.post2('/uniteuser/sys/user/changePasswordForUser', {
            password: md5(this.form.oldPassword),
            newPassword: md5(this.form.newPassword)
          }).then((res) => {
            this.$message({
              message: '修改密码成功',
              type: 'success'
            });
            this.$emit('success')
            this.resetForm()
          })
        }
      });
    },
    resetForm() {
      this.$refs['form'].resetFields();
    },
    close() {
      this.resetForm()
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog_wrap {
  /deep/ .el-dialog__title {
    position: relative;
    padding-left: 15px;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 60%;
      transform: translateY(-50%);
      display: block;
      width: 3px;
      height: 14px;
      background: #1e78eb;
      border-radius: 2px;
    }
  }
  /deep/ .el-form-item {
    margin-bottom: 10px;
    position: relative;
    .el-form-item__label {
      width: 100%;
      text-align: left;
    }
    .el-input {
      width: 100%;
      .el-input__inner {
        width: 100%;
      }
    }
  }
  img {
    position: absolute;
    bottom: 12px;
    right: 32px;
  }
  .no-tips {
    /deep/ .el-form-item__content {
      line-height: 20px;
      width: 100%;
      float: left;
    }
  }
  .tips {
    color: $color-font-support;
  }
  .submit-btn {
    width: 100%;
    margin-top: 30px;
  }
  .new-password {
    /deep/ .el-form-item__content {
      line-height: 20px;
      .tips {
        display: inline-block;
        margin-bottom: 8px;
      }
    }
  }
}
/deep/ .el-dialog__header {
  padding: 0 20px;
  line-height: 50px;
  .el-dialog__headerbtn {
    top: 2px;
    font-size: 20px;
  }
}
/deep/ .el-dialog__body {
  border-bottom: 1px solid $border-light;
  border-top: 1px solid $border-light;
  padding: 12px 20px;
}
.body {
  li {
    line-height: 30px;
    display: flex;
    label {
      width: 105px;
      text-align: right;
      display: inline-block;
      color: $color-font-support;
    }
    span {
      flex: 1;
      color: $color-font-main;
    }
  }
}

@media screen and (min-width: 1441px) and (max-width: 1921px) {
  .dialog_wrap {
    /deep/ .el-button {
      font-size: 16px;
    }
  }
}
@media screen and (min-width: 1921px) {
  .dialog_wrap {
    /deep/ .el-button {
      font-size: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/common/PasswordDialog.vue